module.exports = __webpack_public_path__ + "static/why-popup--1-d50094ef75476330af2c4f9d90ee977e.png";